function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import * as base64url from '../runtime/base64url.js';
import { decoder } from '../lib/buffer_utils.js';
import { JWTInvalid } from '../util/errors.js';
import jwtPayload from '../lib/jwt_claims_set.js';
import { ProduceJWT } from './produce.js';
export var UnsecuredJWT = /*#__PURE__*/function (_ProduceJWT) {
  function UnsecuredJWT() {
    _classCallCheck(this, UnsecuredJWT);
    return _callSuper(this, UnsecuredJWT, arguments);
  }
  _inherits(UnsecuredJWT, _ProduceJWT);
  return _createClass(UnsecuredJWT, [{
    key: "encode",
    value: function encode() {
      var header = base64url.encode(JSON.stringify({
        alg: 'none'
      }));
      var payload = base64url.encode(JSON.stringify(this._payload));
      return "".concat(header, ".").concat(payload, ".");
    }
  }], [{
    key: "decode",
    value: function decode(jwt, options) {
      if (typeof jwt !== 'string') {
        throw new JWTInvalid('Unsecured JWT must be a string');
      }
      var _jwt$split = jwt.split('.'),
        encodedHeader = _jwt$split[0],
        encodedPayload = _jwt$split[1],
        signature = _jwt$split[2],
        length = _jwt$split.length;
      if (length !== 3 || signature !== '') {
        throw new JWTInvalid('Invalid Unsecured JWT');
      }
      var header;
      try {
        header = JSON.parse(decoder.decode(base64url.decode(encodedHeader)));
        if (header.alg !== 'none') throw new Error();
      } catch (_unused) {
        throw new JWTInvalid('Invalid Unsecured JWT');
      }
      var payload = jwtPayload(header, base64url.decode(encodedPayload), options);
      return {
        payload: payload,
        header: header
      };
    }
  }]);
}(ProduceJWT);